import {gql} from "@apollo/client";
import {VoucherClearingLogFilterType,VoucherClearingLogType} from "../types/VoucherClearingLogType";

export const FIELDS = `
    id
    businessId
    clearingId
    pricingId
    snapshotDataJson
    description
    logEvent
    reRunTaskId
    operatorId
    createdAt
`;

export const GET_VOUCHER_CLEARING_LOG_LISTING = gql`
    query VoucherClearingQuery($filters: VoucherClearingLogFilterTypeInput,
                       $pageRequest: PageRequestTypeInput) {
        getVoucherClearingLogPageable(filters: $filters, pageRequest: $pageRequest) {
            content{
                ${FIELDS}
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface VoucherClearingLogListResponse {
    getVoucherClearingLogPageable: VoucherClearingLogResponseType;
}

export interface VoucherClearingLogResponseType {
    content: VoucherClearingLogType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

interface VoucherClearingLogTypeInput {
    filters?: VoucherClearingLogFilterType;
    pageRequest?: PageRequestTypeInput;
}

interface PageRequestTypeInput {
    page: number;
    size: number;
    sortBy: string;
    sortDirection: string;
}

